(function() {
    'use strict';

    angular.module('app.turnos', []);
})();
